document.addEventListener('DOMContentLoaded', function () {
    devtricker_navbarChangePositionToStickyOnScrollUp();
});

function devtricker_navbarChangePositionToStickyOnScrollUp() {
    let lastScrollY = window.scrollY;
    let nav = document.getElementById('main-nav');

    window.addEventListener('scroll', () => {
        if (window.scrollY === 0) {
            nav.style.transition = 'none';
            nav.style.transition = 'background-color 1s';
            nav.style.boxShadow = 'none';

        } else if (window.scrollY < lastScrollY) {
            nav.style.transition = 'none';
            nav.classList.add('sticky');
            nav.style.boxShadow = '0 -2px 4px -2px var(--comment-form-shadow), 0 3px 6px -2px var(--comment-form-shadow)';
        } else if (window.scrollY > lastScrollY) {
            nav.style.transition = 'none';
            nav.classList.remove('sticky');
            nav.style.boxShadow = 'none';
        }

        lastScrollY = window.scrollY;
    });
}